import { FCX } from "@datassential/platform-ui-lib";
import TabList from "@components/new/TabList/TabList";
import cn from "classnames";
import './TrendingNowHeader.scss';

export interface TrendingNowTab {
    id: string;
    title: string;
}

interface TrendingNowHeaderProps {
    tabs: TrendingNowTab[];
    containerId: string;
    offset?: number;
    isScrolled?: boolean;
}

const TrendingNowHeader: FCX<TrendingNowHeaderProps> = ({
  tabs,
  containerId,
  offset = 0,
  isScrolled = false,
}) => {
    return (
        <div className={cn("TrendingNowHeader", { "is-scrolled": isScrolled })}>
            <h1 className="TrendingNowHeader__title">Trending Now</h1>
            <TabList
                className="TrendingNowHeader__tabs"
                data={tabs}
                containerId={containerId}
                offset={offset}
            />
        </div>
    );
};

export default TrendingNowHeader;
